import { useEffect, useState } from 'react';
import { getAPIKeys } from 'src/api/stoApi';
import { apiErrorHandling } from '../api/apierrorhandling';
import { generalStore } from '../stores/GeneralStore';
import { IGetAPIResponseItem } from 'src/models';

export const useAPIKeys = (reload: boolean) => {
  const [apiKeys, setAPIKeys] = useState<IGetAPIResponseItem[] | null>(null);
  const load = async () => {
    generalStore.setIsLoading(true);
    try {
      const response = (await getAPIKeys()).data;
      setAPIKeys(response.data);
    } catch (error: any) {
      apiErrorHandling(error, 'Error loading SPV');
    } finally {
      generalStore.setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [reload]);

  return apiKeys;
};
